// extracted by mini-css-extract-plugin
export default {"wrap":"referencesUserArchive_wrap__fM3r3"};